import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { addToast } from 'modules/messageSystem/actions/addToast';
import { addModal } from 'modules/messageSystem/actions/addModal';
import * as modalCodes from 'modules/messageSystem/constants/modalCodes';

import createAction from './';
import { DELETE_CONSULTATION_MEDIA } from '../services/deleteConsultationMedia';


export const CONSULTATION_MEDIA_DELETE = createAsyncAction(createAction('CONSULTATION_MEDIA_DELETE'));

const deleteConsultationMedia = ({ id, comment }) => (dispatch, getState) => {
  const state = getState();
  const { appointmentId } = state.appointmentInfo.currentAppointment;

  const apiCallParams = {
    mutation: DELETE_CONSULTATION_MEDIA,
    variables: {
      metaDataId: id,
      appointmentId,
    },
    fetchPolicy: 'no-cache',
  };

  dispatch({ type: CONSULTATION_MEDIA_DELETE.pending});

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(() => {
      dispatch({
        type: CONSULTATION_MEDIA_DELETE.success,
        payload: { metaDataId: id },
      });

      return dispatch(addToast('info', 'file-was-deleted-toast', {
        id: 'Media.MediaDelete.Customer.OperationSuccessfulSnackbar.body',
        defaultMessage: '** {mediaTitle} was deleted.',
        values: { mediaTitle: comment || { id: 'schedule.patientInfoTab.media', defaultMessage: '** Media' } },
      }));

    })
    .catch((err) => dispatch(errorAction(CONSULTATION_MEDIA_DELETE.failure, err)));
};

export const deleteConsultationMediaWithConfirm = ({ id, comment }) => (dispatch) => {
  return new Promise((resolve, reject) => dispatch(
    addModal({
      testId: 'delete-media-file-modal',
      typeId: modalCodes.MODAL_CONSULTATION_MEDIA_DELETE,
      preventClosingWhenDismiss: true,
      canAddDuplicate: false,
      isForce: true,
      onOk: () => resolve(dispatch(deleteConsultationMedia({ id, comment }))),
      onCancel: reject,
    }),
  ));
};
